export enum ChipType {
    None = "",
    Assist = "Assist",
    Filter = "Filter",
    Input = "Input",
    Suggestion = "Suggestion"
}